import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardActions,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TablePagination,
} from '@material-ui/core';

import { FormattedMessage } from 'react-intl';
import Skeleton from '@material-ui/lab/Skeleton';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles(() => ({
  root: {},
  content: {
    padding: 0,
  },
  inner: {
    minWidth: 1050,
  },
  actions: {
    justifyContent: 'flex-end',
  },
}));

const CredentialRequestsTable = props => {
  const {
    className,
    credentialRequests,
    handleConnect,
    handlePageChange,
    handleRowsPerPageChange,
    page,
    rowsPerPage,
    totalCount,
    loading,
    ...rest
  } = props;

  const classes = useStyles();

  return (
    <Card {...rest} className={clsx(classes.root, className)}>
      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <div className={classes.inner}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <FormattedMessage id="credentialRequests.name" />
                  </TableCell>
                  <TableCell>
                    <FormattedMessage id="credentialRequests.organization" />
                  </TableCell>
                  <TableCell>
                    <FormattedMessage id="credentialRequests.packageType" />
                  </TableCell>
                  <TableCell>
                    <FormattedMessage id="credentialRequests.createdAt" />
                  </TableCell>
                  <TableCell>
                    <FormattedMessage id="credentialRequests.connect" />
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading &&
                  new Array(rowsPerPage)
                    .fill(index => index)
                    .map((value, index) => (
                      <TableRow className={classes.tableRow} key={index}>
                        <TableCell>
                          <Skeleton />
                        </TableCell>
                        <TableCell>
                          <Skeleton />
                        </TableCell>
                        <TableCell>
                          <Skeleton />
                        </TableCell>
                        <TableCell>
                          <Skeleton />
                        </TableCell>
                        <TableCell>
                          <Skeleton />
                        </TableCell>
                      </TableRow>
                    ))}
                {!loading &&
                  credentialRequests.map(credentialRequest => (
                    <TableRow className={classes.tableRow} hover key={credentialRequest.requestId}>
                      <TableCell>
                        <div className={classes.nameContainer}>
                          <Typography variant="body1">{credentialRequest.name}</Typography>
                        </div>
                      </TableCell>
                      <TableCell>{credentialRequest.organization.organizationName}</TableCell>
                      <TableCell>
                        <FormattedMessage id={`packages.type.${credentialRequest.packageType}`} />
                      </TableCell>
                      <TableCell>{moment(credentialRequest.createdAt).format('L')}</TableCell>
                      <TableCell>
                        <Button
                          variant="outlined"
                          color="primary"
                          href={`${process.env.REACT_APP_AUTH_URL}/connect/${credentialRequest.packageType}/${credentialRequest.requestId}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <FormattedMessage id="credentialRequests.connect" />
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
      <CardActions className={classes.actions}>
        <TablePagination
          showFirstButton
          showLastButton
          component="div"
          count={totalCount}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handleRowsPerPageChange}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5, 10, 25, 50, 100]}
        />
      </CardActions>
    </Card>
  );
};

CredentialRequestsTable.propTypes = {
  className: PropTypes.string,
  credentialRequests: PropTypes.array.isRequired,
};

export default CredentialRequestsTable;
